import * as React from "react";
const SvgChevron = props => <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" viewBox="0 0 20 20" {...props}><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="m12.5 15-5-5 5-5" /></svg>;
export default SvgChevron;